import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEditSupplier } from "../../redux/slices/supplier";
import { FaPhone, FaEnvelope, FaPercent } from "react-icons/fa6";
import NoData from "../ui/NoData";
import { num } from "../../utils/format";

const List = () => {
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.suppliers.list);
  const keys = Object.keys(suppliers ?? {});

  if (keys.length === 0) return <NoData />;

  return (
    <div className="space-y-3">
      {keys.map((key) => {
        const s = suppliers[key];
        return (
          <button
            key={key}
            onClick={() => dispatch(setEditSupplier(key))}
            className="block w-full overflow-hidden rounded-2xl border border-brand-600/10 bg-white text-left
                       shadow-card transition active:scale-[0.99]"
          >
            <div className="bg-brand-600 px-4 py-2.5">
              <h3 className="truncate font-semibold text-white">{s.name}</h3>
            </div>
            <div className="grid grid-cols-1 gap-1.5 px-4 py-3 text-sm text-slate-600">
              <div className="flex items-center gap-2 truncate">
                <FaPhone className="shrink-0 text-brand-500" size={13} /> {s.phone || "—"}
              </div>
              <div className="flex items-center gap-2 truncate">
                <FaEnvelope className="shrink-0 text-brand-500" size={13} /> {s.email || "—"}
              </div>
              <div className="flex items-center gap-2 truncate">
                <FaPercent className="shrink-0 text-brand-500" size={13} /> Προμήθεια {num(s.commission)}%
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default List;
